/*
 * Silver Gardens
 * Collection / Search Card Configurator V2.1
 *
 * Responsive image sizing with extra detail for desktop and mobile.
 */

(function () {
  "use strict";

  // The browser applies screen pixel density separately.
  var IMAGE_QUALITY_FACTOR = 1.5;

  if (
    window.SGProductCardConfigurator &&
    window.SGProductCardConfigurator.ready
  ) {
    // Keep initialization idempotent if the theme editor re-executes this asset.
    return;
  }

  function configImageSrcset(image) {
    if (!image || !/([?&])width=\d+/.test(image)) {
      return "";
    }
    return [240, 360, 540, 720, 900, 1200].map(function (width) {
      return image.replace(/([?&]width=)\d+/, "$1" + width) + " " + width + "w";
    }).join(", ");
  }

  function readConfig(node) {
    return {
      node: node,
      variantId: node.dataset.variantId || "",
      pot: node.dataset.pot || "",
      height: node.dataset.height || "",
      color: node.dataset.color || "",
      available: node.dataset.available === "true",
      price: node.dataset.price || "",
      comparePrice: node.dataset.comparePrice || "",
      hasCompare: node.dataset.hasCompare === "true",
      url: node.dataset.url || "",
      image: node.dataset.image || "",
      imageSrcset: node.dataset.imageSrcset || configImageSrcset(node.dataset.image || ""),
      linkedPotId: node.dataset.linkedPotId || ""
    };
  }

  function getConfigs(card) {
    return Array.prototype.map.call(
      card.querySelectorAll("[data-sg-card-config]"),
      readConfig
    );
  }

  function isNurseryPot(value) {
    return String(value || "")
      .toLowerCase()
      .indexOf("nursery") !== -1;
  }

  function matches(config, criteria) {
    return Object.keys(criteria).every(function (key) {
      return criteria[key] === undefined || config[key] === criteria[key];
    });
  }

  function configExists(configs, criteria) {
    return configs.some(function (config) {
      return matches(config, criteria);
    });
  }

  function availableConfigExists(configs, criteria) {
    return configs.some(function (config) {
      return config.available && matches(config, criteria);
    });
  }

  function firstAvailable(configs, criteria) {
    return (
      configs.find(function (config) {
        return config.available && matches(config, criteria || {});
      }) || null
    );
  }

  function findInitialConfig(card, configs) {
    var variantId = card.getAttribute("data-sg-card-variant-id");

    var byId = configs.find(function (config) {
      return config.variantId === variantId;
    });

    if (byId && byId.available) {
      return byId;
    }

    var initialPot = card.dataset.sgInitialPot || "";
    var initialHeight = card.dataset.sgInitialHeight || "";
    var initialColor = card.dataset.sgInitialColor || "";

    var exact = configs.find(function (config) {
      return (
        config.available &&
        config.pot === initialPot &&
        config.height === initialHeight &&
        config.color === initialColor
      );
    });

    if (exact) {
      return exact;
    }

    var sameHeightWhite = configs.find(function (config) {
      return (
        config.available &&
        config.height === initialHeight &&
        config.color.toLowerCase() === "white"
      );
    });

    if (sameHeightWhite) {
      return sameHeightWhite;
    }

    var sameHeight = firstAvailable(configs, {
      height: initialHeight
    });

    if (sameHeight) {
      return sameHeight;
    }

    return firstAvailable(configs, {}) || configs[0] || null;
  }

  function scoreCandidate(candidate, current, changedOption) {
    var score = 0;

    ["height", "pot", "color"].forEach(function (key) {
      if (key === changedOption) {
        return;
      }

      if (candidate[key] === current[key]) {
        score += key === "height" || key === "pot" ? 6 : 4;
      }
    });

    if (
      !isNurseryPot(candidate.pot) &&
      candidate.color.toLowerCase() === "white"
    ) {
      score += 2;
    }

    if (isNurseryPot(candidate.pot)) {
      score += 1;
    }

    return score;
  }

  function chooseConfig(configs, current, changedOption, changedValue) {
    var desired = {
      pot: current.pot,
      height: current.height,
      color: current.color
    };

    desired[changedOption] = changedValue;

    var exact = configs.find(function (config) {
      return (
        config.available &&
        config.pot === desired.pot &&
        config.height === desired.height &&
        config.color === desired.color
      );
    });

    if (exact) {
      return exact;
    }

    var candidates = configs.filter(function (config) {
      return (
        config.available &&
        config[changedOption] === changedValue
      );
    });

    if (!candidates.length) {
      return null;
    }

    candidates.sort(function (a, b) {
      return (
        scoreCandidate(b, current, changedOption) -
        scoreCandidate(a, current, changedOption)
      );
    });

    return candidates[0];
  }

  function updateHeightButton(button, current, configs) {
    var value = button.dataset.value || "";
    var exists = configExists(configs, { height: value });
    var available = availableConfigExists(configs, { height: value });
    var selected = current.height === value;

    button.hidden = !exists;
    button.disabled = exists && !available;
    button.classList.toggle("is-selected", selected);
    button.classList.toggle("is-unavailable", exists && !available);
    button.setAttribute("aria-pressed", selected ? "true" : "false");
  }

  function updatePotButton(button, current, configs) {
    var value = button.dataset.value || "";

    var criteria = {
      height: current.height,
      pot: value
    };

    var exists = configExists(configs, criteria);
    var available = availableConfigExists(configs, criteria);
    var selected = current.pot === value;

    button.hidden = !exists;
    button.disabled = exists && !available;
    button.classList.toggle("is-selected", selected);
    button.classList.toggle("is-unavailable", exists && !available);
    button.setAttribute("aria-pressed", selected ? "true" : "false");
  }

  function updateColorButton(button, current, configs) {
    var value = button.dataset.value || "";

    var criteria = {
      height: current.height,
      pot: current.pot,
      color: value
    };

    var exists = configExists(configs, criteria);
    var available = availableConfigExists(configs, criteria);
    var selected = current.color === value;

    button.hidden = !exists;
    button.disabled = exists && !available;
    button.classList.toggle("is-selected", selected);
    button.classList.toggle("is-unavailable", exists && !available);
    button.setAttribute("aria-pressed", selected ? "true" : "false");
  }

  function updateButtons(card, current, configs) {
    card
      .querySelectorAll('[data-sg-option-button][data-option="height"]')
      .forEach(function (button) {
        updateHeightButton(button, current, configs);
      });

    card
      .querySelectorAll('[data-sg-option-button][data-option="pot"]')
      .forEach(function (button) {
        updatePotButton(button, current, configs);
      });

    var colorRow = card.querySelector("[data-sg-color-row]");

    var colorButtons = card.querySelectorAll(
      '[data-sg-option-button][data-option="color"]'
    );

    var visibleColorCount = 0;

    colorButtons.forEach(function (button) {
      updateColorButton(button, current, configs);

      if (!button.hidden) {
        visibleColorCount += 1;
      }
    });

    if (colorRow) {
      colorRow.hidden =
        isNurseryPot(current.pot) ||
        visibleColorCount === 0;
    }
  }

  function updatePrice(card, config) {
    var price = card.querySelector("[data-sg-card-price]");

    var comparePrice = card.querySelector(
      "[data-sg-card-compare-price]"
    );

    if (price) {
      price.textContent = config.price;
      price.classList.toggle("sale", config.hasCompare);
    }

    if (comparePrice) {
      comparePrice.textContent = config.comparePrice;
      comparePrice.hidden = !config.hasCompare;
    }
  }

  function getMainImage(card) {
    var image = card.querySelector(
      ".product-item__image-link .product-item__image img"
    );

    if (!image) {
      image = card.querySelector(".product-item__image-link img");
    }

    return image;
  }

  function getRenderedImageSizes(image) {
    var bounds = image.getBoundingClientRect();

    // Hidden cards are measured again when they become visible.
    if (!bounds.width || !bounds.height) {
      return "";
    }

    var sourceWidth =
      image.naturalWidth ||
      Number(image.getAttribute("width"));

    var sourceHeight =
      image.naturalHeight ||
      Number(image.getAttribute("height"));

    var displayWidth = bounds.width;

    // Include the extra scale caused by cover cropping.
    if (
      sourceWidth > 0 &&
      sourceHeight > 0 &&
      window.getComputedStyle(image).objectFit === "cover"
    ) {
      displayWidth = Math.max(
        displayWidth,
        bounds.height * sourceWidth / sourceHeight
      );
    }

    return Math.ceil(displayWidth * IMAGE_QUALITY_FACTOR) + "px";
  }

  function syncImageSizes(card) {
    var image = getMainImage(card);

    if (!image) {
      return;
    }

    var sizes = getRenderedImageSizes(image);

    if (sizes && image.getAttribute("sizes") !== sizes) {
      image.setAttribute("sizes", sizes);
    }
  }

  function scheduleImageSizing(card) {
    if (card._sgImageSizingQueued) {
      return;
    }

    card._sgImageSizingQueued = true;

    window.requestAnimationFrame(function () {
      card._sgImageSizingQueued = false;
      syncImageSizes(card);
    });
  }

  function setupImageSizing(card) {
    if (card._sgImageSizingReady) {
      return;
    }

    var image = getMainImage(card);

    if (!image) {
      return;
    }

    card._sgImageSizingReady = true;

    // Update sizing after a variant image with a different ratio loads.
    image.addEventListener("load", function () {
      scheduleImageSizing(card);
    });

    if ("ResizeObserver" in window) {
      card._sgImageResizeObserver = new window.ResizeObserver(
        function () {
          scheduleImageSizing(card);
        }
      );

      card._sgImageResizeObserver.observe(image);
    }

    syncImageSizes(card);
  }

  function updateImage(card, config) {
    if (!config.image) {
      return;
    }

    var image = getMainImage(card);

    if (!image) {
      return;
    }

    // Apply measured sizing before changing the image sources.
    syncImageSizes(card);

    if (config.imageSrcset) {
      image.setAttribute("srcset", config.imageSrcset);
    } else {
      image.removeAttribute("srcset");
    }

    image.setAttribute("src", config.image);
  }

  function updateLinks(card, config) {
    if (!config.url) {
      return;
    }

    var imageLink = card.querySelector(".product-item__image-link");

    var titleLink = card.querySelector(
      ".product-item__product-title a"
    );

    if (imageLink) {
      imageLink.href = config.url;
    }

    if (titleLink) {
      titleLink.href = config.url;
    }

    // Keep the full-page link in sync with selected height / pot / colour.
    card
      .querySelectorAll("[data-sg-card-product-page-link]")
      .forEach(function (link) {
        link.href = config.url;
      });

    card
      .querySelectorAll(".product-item__product-form-variant-input")
      .forEach(function (input) {
        input.value = config.variantId;
      });
  }

  function applyConfig(card, config, configs, keepServerImage) {
    if (!config) {
      return;
    }

    card._sgCurrentConfig = config;

    card.setAttribute(
      "data-sg-card-variant-id",
      config.variantId
    );

    updateButtons(card, config, configs);
    updatePrice(card, config);
    // Liquid has already rendered the right initial image for this variant.
    // Avoid reassigning src/srcset on mobile homepage initialization.
    if (!keepServerImage) {
      updateImage(card, config);
    }
    updateLinks(card, config);
  }

  // Alternate variant images load only after a shopper selects that option.
  // Avoid prefetching every combination for cards that may never be opened.

  function initCard(card) {
    if (card._sgConfiguratorReady) {
      scheduleImageSizing(card);
      return;
    }

    var configs = getConfigs(card);

    if (!configs.length) {
      return;
    }

    var initialConfig = findInitialConfig(card, configs);

    if (!initialConfig) {
      return;
    }

    card._sgConfiguratorReady = true;
    card._sgConfigs = configs;

    setupImageSizing(card);
    var keepServerImage =
      deferOffscreenCards &&
      card.getAttribute("data-sg-card-variant-id") === initialConfig.variantId;
    applyConfig(card, initialConfig, configs, keepServerImage);

    card
      .querySelectorAll("[data-sg-option-button]")
      .forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (button.disabled || button.hidden) {
            return;
          }

          var current = card._sgCurrentConfig;

          if (!current) {
            return;
          }

          var option = button.dataset.option;
          var value = button.dataset.value;

          var next = chooseConfig(
            configs,
            current,
            option,
            value
          );

          if (!next) {
            return;
          }

          applyConfig(card, next, configs);
        });
      });


  }

  function init(root) {
    var scope = root || document;

    scope
      .querySelectorAll('.product-item[data-sg-configurator="true"]')
      .forEach(initCard);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  window.SGProductCardConfigurator = {
    ready: true,
    init: init
  };

  // Also handles orientation changes and the ResizeObserver fallback.
  var resizeQueued = false;

  window.addEventListener("resize", function () {
    if (resizeQueued) {
      return;
    }

    resizeQueued = true;

    window.requestAnimationFrame(function () {
      resizeQueued = false;

      document
        .querySelectorAll('.product-item[data-sg-configurator="true"]')
        .forEach(function (card) {
          // Preserve lazy initialization on the mobile homepage: resize must
          // not measure offscreen cards before the observer initializes them.
          // Other pages and desktop retain their original resize behavior.
          if (deferOffscreenCards && !card._sgConfiguratorReady) {
            return;
          }
          syncImageSizes(card);
        });
    });
  });

  // Homepage mobile: initialize configurable cards only as they approach view.
  // Liquid renders the initial image, price and selected options. This avoids
  // measuring and updating every offscreen card before the hero is painted.
  // All other templates, desktop and the theme editor retain eager init.
  var deferOffscreenCards =
    document.body &&
    document.body.classList.contains("template-index") &&
    window.matchMedia &&
    window.matchMedia("(max-width: 719px)").matches &&
    "IntersectionObserver" in window &&
    !(window.Shopify && window.Shopify.designMode);

  if (deferOffscreenCards) {
    var cardObserver = new window.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          cardObserver.unobserve(entry.target);
          initCard(entry.target);
        });
      },
      { rootMargin: "500px 0px" }
    );

    document
      .querySelectorAll('.product-item[data-sg-configurator="true"]')
      .forEach(function (card) {
        cardObserver.observe(card);
      });
  } else {
    init(document);
  }
})();